<div class="container">
  <div class="row">
    <div class="col" style="text-align: right;">
      <button (click)="closeClicked()" mat-button class="button-class">Close</button>
    </div>
  </div>
  <!-- <mat-card style="padding: 7px; color: black;" > -->
  <div class="row" *ngIf="booth_details!=null">
    <div class="col">
      <span>Shop name</span> : <span>{{booth_details['name']}}</span> &nbsp;<br>
      <span>Agent name</span> : <span>{{booth_details['agent_first_name']}}
        {{booth_details['last_name']}}</span><br>
      <span>Phone number</span> : <span>{{booth_details['agent_mobile_number']}}</span><br>
      <span>Address</span> : <span>{{booth_details['address']}}</span><br>
      <span>landmark</span> : <span>{{booth_details['landmark']}}</span><br>
      <span>Working hours</span> : <span>{{booth_details['working_hours_from']}} to
        {{booth_details['working_hours_to']}} </span>
    </div>
  </div><br>
  <div class="row">
    <div class="col" style="text-align: center;">
      <button (click)="confirmCicked(booth_details.business_id)" mat-button class="button-class">Choose</button>
    </div>
  </div>
  <!-- </mat-card> -->
</div>
